module.exports = __webpack_public_path__ + "static/media/deleteIcons.4d25563d.svg";